import React, { Component } from 'react'
import TopBar from './topBar'

export default class TestVersionWarning extends Component {
  render () {
    return (
      <TopBar className='test-version-warning'>
        <strong>WARNING:</strong> This is a test version of Isha Stay, it cannot
        be used to take customer bookings
      </TopBar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/topBars/testVersionWarning.js